import styled from "styled-components";

const PanelWrapper = styled.section`
  width: 100%;
  /* min-height: 100%; */
  padding-top: 80px;
  background: "transparent";
`;

export default PanelWrapper;
